import {useTheme} from '@mui/material/styles';

export const SaveBoardStyles = () => {
  return {
    "& .saveBoardForm": {
      padding: "16px 0",
      "& .saveMessage": {
        marginBottom: 0,
      },
      "&__actions": {
        "& button": {
          margin: "0 8px"
        }
      },
      "&__form": {
        padding: "0 8px"
      },
    },
    "& .saveBoard__FormItem": {
      width: "50%",
      display: "inline-block",
      verticalAlign: "top",
    },
    "& .statusMessage .MuiAlert-message": {
      fontWeight: "bold",
    },
  }
}

export const InputTextStyles = () => {
  const theme = useTheme();

  return ({
    '& .MuiInputBase-root, MuiOutlinedInput-input': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },

    '& .MuiInputLabel-root': {
      color: '#fff',

      top: '0px',
    },

    '& label.Mui-focused': {
      color: 'white',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'white',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: 'white',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
    },
  })
}
